import { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';

const WrappedTextField = ({ disabled, value, onChange, id, InputLabelProps, label, name, onBlur, onKeyDown }) => {
  const [localState, setLocalState] = useState(value)

  useEffect(() => {
    setLocalState(value)
  }, [value])

  const handleChange = (e, submit) => {
    setLocalState(e.target.value)
    onChange(e, submit)
  }

  return (
    <TextField
      disabled={disabled}
      InputLabelProps={{ ...{ shrink: true }, ...InputLabelProps }}
      id={id}
      label={label}
      value={localState || ""}
      name={name}
      onChange={(e) => handleChange(e, false)}
      onBlur={
        onBlur
          ? onBlur
          : (e) => handleChange(e, true)}
      onKeyDown={
        onKeyDown
          ? onKeyDown
          : (e) => {
            if (e.key === "Enter") {
              e.target.blur();
              handleChange(e, true);
            }
          }}
    />
  );
}

export default WrappedTextField;
